import { Bell, CalendarDays, CheckSquare, Film, LifeBuoy, Mail, MessageCircle, Users } from 'lucide-react';
import type { Notification } from '@unitly/contracts';
import { Avatar } from '../../ui/primitives.tsx';

const KIND_ICON: Array<[prefix: string, icon: typeof Bell]> = [
  ['crm.', Mail], ['chat.', MessageCircle], ['task', CheckSquare], ['content', Film],
  ['ticket.', LifeBuoy], ['hr.', Users], ['event', CalendarDays],
];

/** Who or what a notification is about: the person who did it, or - for ones with no Unitly author,
 * like a contact's email reply - an icon for its kind instead of an empty circle. */
export function NotificationIcon({ n, size }: { n: Notification; size: number }) {
  if (n.actor) return <Avatar id={n.actor.id} name={n.actor.displayName} avatarUrl={n.actor.avatarUrl} size={size} />;
  const Icon = KIND_ICON.find(([prefix]) => n.kind.startsWith(prefix))?.[1] ?? Bell;
  return (
    <span className="avatar" style={{ '--size': `${size}px`, '--avatar-bg': 'var(--fill)', color: 'var(--label-2)' } as React.CSSProperties} aria-hidden="true">
      <Icon size={Math.round(size * 0.48)} />
    </span>
  );
}
